define('hbs/underscore',{});
